"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _structures = require("./structures");

var _constants = _interopRequireDefault(require("./constants"));

var _tools = _interopRequireDefault(require("./tools"));

var _time = _interopRequireDefault(require("./time"));

var _file = _interopRequireDefault(require("./file"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var compression = {
  Uncompressed: 0,
  BZ2: 1,
  LZ4: 2
};

var Bag =
/*#__PURE__*/
function () {
  function Bag() {
    _classCallCheck(this, Bag);

    this.compression = compression.Uncompressed;
    this.chunkThreshold = 768 * 1024;
    this.fileSize = 0;
    this.fileHeaderPos = 0;
    this.indexDataPos = 0;
    this.connectionCount = 0;
    this.chunkCount = 0;
    this.chunkOpen = false;
    this.currChunkDataPos = 0;
    this.file = new _file["default"]();
    this.currChunkInfo = new _structures.ChunkInfo();
    this.topicConnectionsIDs = {};
    this.connections = {};
    this.chunks = [];
    this.connectionIndexes = {};
    this.currChunkConnectionIndexes = {};
    this.outgoingChunkBuffer = Buffer.alloc(0);
    this.open();
  }

  _createClass(Bag, [{
    key: "open",
    value: function open() {
      this.file.openWrite();
      var version = Buffer.from('#ROSBAG V' + _constants["default"].VERSION + '\n');
      this.file.write(version);
      this.fileHeaderPos = this.file.offset;
      this.writeFileHeaderRecord();
      var offset = this.file.offset;
      this.file.seek(0, 2);
      this.fileSize = this.file.offset;
      this.file.seek(offset);
    }
  }, {
    key: "close",
    value: function close() {
      if (!this.file.isOpen()) {
        return;
      }

      this.stopWriting();
      return this.file.close();
    }
  }, {
    key: "write",
    value: function write(topic, msg) {
      var time = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var connection_header = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      if (!this.file.isOpen()) {
        throw new Error('Bag file is not open');
      }

      if (!topic || typeof topic !== 'string') {
        throw new Error('Topic is invalid');
      }

      if (time === null) {
        time = new _time["default"](0, 0);
      }

      var connectionInfo = null;
      var connID = 0;

      if (!connection_header) {
        if (this.topicConnectionsIDs.hasOwnProperty(topic)) {
          connID = this.topicConnectionsIDs[topic];
          connectionInfo = this.connections[connID];
        } else {
          connID = Object.keys(this.connections).length;
          this.topicConnectionsIDs[topic] = connID;
        }
      } else {
        console.log('connection_header is not null');
      }

      this.file.seek(0, 2);
      this.fileSize = this.file.offset;

      if (!this.chunkOpen) {
        this.startWritingChunk(time);
      }

      if (connectionInfo === null) {
        connectionInfo = new _structures.ConnectionInfo();
        connectionInfo.id = connID;
        connectionInfo.topic = topic;
        connectionInfo.datatype = msg.messageType;
        connectionInfo.md5sum = msg.md5;
        connectionInfo.msg_def = msg.messageDefinition;

        if (connection_header !== null) {
          connectionInfo.header = Object.apply({}, connection_header);
        } else {
          connectionInfo.header = {};
          connectionInfo.header['md5sum'] = connectionInfo.md5sum;
          connectionInfo.header['message_definition'] = connectionInfo.msg_def;
          connectionInfo.header['type'] = connectionInfo.datatype;
        }

        this.connections[connID] = connectionInfo;
        this.currChunkInfo.connection_counts[connectionInfo.id] = 0;
        this.currChunkConnectionIndexes[connectionInfo.id] = [];
        this.connectionIndexes[connectionInfo.id] = [];
        this.writeConnectionRecord(connectionInfo);
        this.outgoingChunkBuffer = _tools["default"].appendConnectionRecordToBuffer(this.outgoingChunkBuffer, connectionInfo);
      }

      var indexEntry = new _structures.IndexEntry();
      indexEntry.time = new _time["default"](time.sec, time.nsec);
      indexEntry.chunk_pos = this.currChunkInfo.pos;
      indexEntry.offset = this.getChunkOffset();
      var chunkConnectionIndex = this.currChunkConnectionIndexes[connectionInfo.id];
      chunkConnectionIndex.push(indexEntry);
      var connectionIndex = this.connectionIndexes[connectionInfo.id];
      connectionIndex.push(indexEntry);
      this.currChunkInfo.connection_counts[connectionInfo.id]++;
      this.writeMessageDataRecord(connID, time, msg);
      var chunkSize = this.getChunkOffset();

      if (chunkSize > this.chunkThreshold) {
        this.stopWritingChunk();
        this.outgoingChunkBuffer.alloc(0);
        this.currChunkInfo.pos = -1;
      }
    }
  }, {
    key: "getChunkOffset",
    value: function getChunkOffset() {
      if (this.compression === compression.Uncompressed) {
        return this.file.offset - this.currChunkDataPos;
      } else {
        console.log('Compression not realized');
      }
    }
  }, {
    key: "writeIndexRecords",
    value: function writeIndexRecords() {
      var _this = this;

      Object.keys(this.currChunkConnectionIndexes).forEach(function (key) {
        var _header;

        var connectionID = key;
        var index = _this.currChunkConnectionIndexes[key];
        var indexSize = index.length;
        var header = (_header = {}, _defineProperty(_header, _constants["default"].CONNECTION_FIELD_NAME, _tools["default"].toHeaderString(connectionID, 32)), _defineProperty(_header, _constants["default"].COUNT_FIELD_NAME, _tools["default"].toHeaderString(indexSize, 32)), _defineProperty(_header, _constants["default"].OP_FIELD_NAME, _tools["default"].toHeaderString(_constants["default"].OP_INDEX_DATA, 8)), _defineProperty(_header, _constants["default"].VER_FIELD_NAME, _tools["default"].toHeaderString(_constants["default"].INDEX_VERSION, 32)), _header);

        _this.writeHeader(header);

        _this.writeDataLength(indexSize * 12);

        index.forEach(function (el) {
          _this.file.write(_tools["default"].toHeaderString(el.time.sec, 32));

          _this.file.write(_tools["default"].toHeaderString(el.time.nsec, 32));

          _this.file.write(_tools["default"].toHeaderString(el.offset, 32));
        });
      });
    }
  }, {
    key: "stopWritingChunk",
    value: function stopWritingChunk() {
      this.chunks.push(Object.assign({}, this.currChunkInfo));
      var uncompressedSize = this.getChunkOffset();
      var compressedSize = this.file.offset - this.currChunkDataPos;
      var endOfChunkPos = this.file.offset;
      this.file.seek(this.currChunkInfo.pos);
      this.writeChunkHeader(this.compression, compressedSize, uncompressedSize);
      this.file.seek(endOfChunkPos);
      this.writeIndexRecords();
      this.currChunkConnectionIndexes = {};
      this.currChunkInfo.connection_counts = {};
      this.chunkOpen = false;
    }
  }, {
    key: "writeFileHeaderRecord",
    value: function writeFileHeaderRecord() {
      var _header2;

      this.connectionCount = Object.keys(this.connections).length;
      this.chunkCount = this.chunks.length;
      var header = (_header2 = {}, _defineProperty(_header2, _constants["default"].CHUNK_COUNT_FIELD_NAME, _tools["default"].toHeaderString(this.chunkCount, 32)), _defineProperty(_header2, _constants["default"].CONNECTION_COUNT_FIELD_NAME, _tools["default"].toHeaderString(this.connectionCount, 32)), _defineProperty(_header2, _constants["default"].INDEX_POS_FIELD_NAME, _tools["default"].toHeaderString(this.indexDataPos, 64)), _defineProperty(_header2, _constants["default"].OP_FIELD_NAME, _tools["default"].toHeaderString(_constants["default"].OP_FILE_HEADER, 8)), _header2);
      var dataLength = 0;

      var headerBuffer = _tools["default"].headerToBuffer(header);

      var headerLength = headerBuffer.length;

      if (headerLength < _constants["default"].FILE_HEADER_LENGTH) {
        dataLength = _constants["default"].FILE_HEADER_LENGTH - headerLength;
      }

      this.file.write(_tools["default"].toHeaderString(headerLength, 32));
      this.file.write(headerBuffer);
      this.file.write(_tools["default"].toHeaderString(dataLength, 32));

      if (dataLength > 0) {
        var padding = ' '.repeat(dataLength);
        this.file.write(padding);
      }
    }
  }, {
    key: "startWritingChunk",
    value: function startWritingChunk(time) {
      this.currChunkInfo.pos = this.file.offset;
      this.currChunkInfo.start_time = new _time["default"](time.sec, time.nsec);
      this.currChunkInfo.end_time = new _time["default"](time.sec, time.nsec);
      this.writeChunkHeader(this.compression, 0, 0);
      this.currChunkDataPos = this.file.offset;
      this.chunkOpen = true;
    }
  }, {
    key: "writeChunkHeader",
    value: function writeChunkHeader(compressionType, compressedSize, uncompressedSize) {
      var _header3;

      var chunkHeader = new _structures.ChunkHeader();

      switch (compressionType) {
        case compression.Uncompressed:
          chunkHeader.compression = _constants["default"].COMPRESSION_NONE;
          break;

        case compression.BZ2:
          chunkHeader.compression = _constants["default"].COMPRESSION_BZ2;
          break;

        case compression.LZ4:
          chunkHeader.compression = _constants["default"].COMPRESSION_LZ4;
          break;

        default:
          throw new Error('Incorrect compression type');
      }

      chunkHeader.compressed_size = compressedSize;
      chunkHeader.uncompressed_size = uncompressedSize;
      var header = (_header3 = {}, _defineProperty(_header3, _constants["default"].COMPRESSION_FIELD_NAME, chunkHeader.compression), _defineProperty(_header3, _constants["default"].OP_FIELD_NAME, _tools["default"].toHeaderString(_constants["default"].OP_CHUNK, 8)), _defineProperty(_header3, _constants["default"].SIZE_FIELD_NAME, _tools["default"].toHeaderString(chunkHeader.uncompressed_size, 32)), _header3);
      this.writeHeader(header);
      this.writeDataLength(chunkHeader.compressed_size);
    }
  }, {
    key: "writeDataLength",
    value: function writeDataLength(dataLength) {
      this.file.write(_tools["default"].toHeaderString(dataLength, 32));
    }
  }, {
    key: "writeHeader",
    value: function writeHeader(header) {
      var headerBuffer = _tools["default"].headerToBuffer(header);

      var len = headerBuffer.length;
      this.file.write(_tools["default"].toHeaderString(len, 32));
      this.file.write(headerBuffer);
    }
  }, {
    key: "writeConnectionRecord",
    value: function writeConnectionRecord(connectionInfo) {
      var _header4;

      var header = (_header4 = {}, _defineProperty(_header4, _constants["default"].CONNECTION_FIELD_NAME, _tools["default"].toHeaderString(connectionInfo.id, 32)), _defineProperty(_header4, _constants["default"].OP_FIELD_NAME, _tools["default"].toHeaderString(_constants["default"].OP_CONNECTION, 8)), _defineProperty(_header4, _constants["default"].TOPIC_FIELD_NAME, connectionInfo.topic), _header4);
      this.writeHeader(header);
      this.writeHeader(connectionInfo.header);
    }
  }, {
    key: "writeMessageDataRecord",
    value: function writeMessageDataRecord(connID, time, msg) {
      var _header5;

      var header = (_header5 = {}, _defineProperty(_header5, _constants["default"].CONNECTION_FIELD_NAME, _tools["default"].toHeaderString(connID, 32)), _defineProperty(_header5, _constants["default"].OP_FIELD_NAME, _tools["default"].toHeaderString(_constants["default"].OP_MSG_DATA, 8)), _defineProperty(_header5, _constants["default"].TIME_FIELD_NAME, Buffer.concat([_tools["default"].toHeaderString(time.sec, 32), _tools["default"].toHeaderString(time.nsec, 32)])), _header5);
      var messageSerLength = msg.getMessageSize(msg);
      this.recordBuffer = new Buffer.alloc(messageSerLength);
      msg.serialize(msg, this.recordBuffer, 0);
      this.file.seek(0, 2);
      this.fileSize = this.file.offset;
      this.writeHeader(header);
      this.writeDataLength(messageSerLength);
      this.file.write(this.recordBuffer);
      this.outgoingChunkBuffer = _tools["default"].appendHeaderToBuffer(this.outgoingChunkBuffer, header);
      this.outgoingChunkBuffer = _tools["default"].appendDataLengthToBuffer(this.outgoingChunkBuffer, messageSerLength);
      this.outgoingChunkBuffer = Buffer.concat([this.outgoingChunkBuffer, this.recordBuffer]);

      if (time.toSec() > this.currChunkInfo.end_time.toSec()) {
        this.currChunkInfo.end_time = time;
      } else if (time.toSec() < this.currChunkInfo.start_time.toSec()) {
        this.currChunkInfo.start_time = time;
      }
    }
  }, {
    key: "writeConnectionRecords",
    value: function writeConnectionRecords() {
      for (var key in this.connections) {
        var connectionInfo = this.connections[key];
        this.writeConnectionRecord(connectionInfo);
      }
    }
  }, {
    key: "writeChunkInfoRecords",
    value: function writeChunkInfoRecords() {
      var _this2 = this;

      this.chunks.forEach(function (chunkInfo) {
        var _header6;

        var chunkConnectionCount = Object.keys(chunkInfo.connection_counts).length;
        var header = (_header6 = {}, _defineProperty(_header6, _constants["default"].CHUNK_POS_FIELD_NAME, _tools["default"].toHeaderString(chunkInfo.pos, 64)), _defineProperty(_header6, _constants["default"].COUNT_FIELD_NAME, _tools["default"].toHeaderString(chunkConnectionCount, 32)), _defineProperty(_header6, _constants["default"].END_TIME_FIELD_NAME, _tools["default"].timeToBuffer(chunkInfo.end_time)), _defineProperty(_header6, _constants["default"].OP_FIELD_NAME, _tools["default"].toHeaderString(_constants["default"].OP_CHUNK_INFO, 8)), _defineProperty(_header6, _constants["default"].START_TIME_FIELD_NAME, _tools["default"].timeToBuffer(chunkInfo.start_time)), _defineProperty(_header6, _constants["default"].VER_FIELD_NAME, _tools["default"].toHeaderString(_constants["default"].CHUNK_INFO_VERSION, 32)), _header6);

        _this2.writeHeader(header);

        _this2.writeDataLength(8 * chunkConnectionCount);

        Object.keys(chunkInfo.connection_counts).forEach(function (key) {
          var connectionID = key;
          var count = chunkInfo.connection_counts[key];

          _this2.file.write(_tools["default"].toHeaderString(connectionID, 32));

          _this2.file.write(_tools["default"].toHeaderString(count, 32));
        });
      });
    }
  }, {
    key: "stopWriting",
    value: function stopWriting() {
      if (this.chunkOpen) {
        this.stopWritingChunk();
      }

      this.file.seek(0, 2);
      this.indexDataPos = this.file.offset;
      this.writeConnectionRecords();
      this.writeChunkInfoRecords();
      this.file.seek(this.fileHeaderPos);
      this.writeFileHeaderRecord();
    }
  }]);

  return Bag;
}();

exports["default"] = Bag;